import React from "react";
import styled from "styled-components";
import { FaPlay } from "react-icons/fa";

const ChairmanMessage = () => {
  return (
    <Wrapper>
      <section
        className="about-section"
        style={{ marginTop: "70px", marginBottom: "70px" }}
      >
        <div className="rs-section-title-wrapper">
          <span className="rs-section-subtitle has-theme-orange justify-content-center">
            <FaPlay color="#EA5501" size={12} />
            Massages From Chairman
          </span>
        </div>

        <div className="container shadow py-4">
          <div className="row g-0">
            {/* Left Image */}
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="video-box">
                <img
                  src="/assets/images/about/about-thumb-12.png"
                  alt="About"
                  className="img-fluid w-100"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-6 col-md-12 col-sm-12 d-flex align-items-center">
              <div className="about-content">
                <div className="section-title">
                  <h2>MESSAGE FROM OUR CHAIRMAN</h2>
                  <h6 className="mb-4">
                    Dear Honourable Valued Customers & Clients,
                  </h6>
                  <p style={{ textAlign: "justify" }}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse varius enim in eros elementum tristique. Duis
                    cursus, mi quis viverra ornare, eros dolor interdum nulla,
                    ut commodo diam libero vitae erat.
                  </p>
                  <p style={{ textAlign: "justify" }}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur et. Donec sed odio dui. Integer posuere erat a
                    ante venenatis dapibus posuere velit aliquet.
                  </p>
                  <p style={{ textAlign: "justify" }}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Curabitur blandit tempus porttitor. Nullam quis risus eget
                    urna mollis ornare vel eu leo. Aenean lacinia bibendum nulla
                    sed consectetur.
                  </p>

                  <div className="text-end">
                    <h6 className="mb-1">Abc Rahman</h6>
                    <p className="mb-0">Chairman</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .about-section {
    /* background: #fff; */
  }

  .video-box {
    overflow: hidden;
    height: 100%;
  }

  .video-box img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .about-content {
    padding: 40px;
  }

  .section-title h2 {
    font-size: 34px;
    font-weight: 700;
    color: #1f1f1f;
    margin-bottom: 20px;
    position: relative;
  }

  .section-title h2::after {
    content: "";
    display: block;
    width: 60px;
    height: 3px;
    background: #ea5501;
    margin-top: 10px;
  }

  .section-title p {
    color: #666;
    font-size: 15px;
    line-height: 28px;
    margin-bottom: 35px;
  }

  .icon-box {
    display: flex;
    align-items: flex-start;
    margin-bottom: 35px;
  }

  .icon {
    width: 70px;
    height: 70px;
    background: #ea5501;
    color: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    flex-shrink: 0;
    margin-right: 20px;
  }

  .content h4 {
    font-size: 20px;
    font-weight: 700;
    color: #222;
    margin-bottom: 10px;
  }

  .content h4:hover {
    color: #ea5501;
    cursor: pointer;
  }

  .content p {
    margin: 0;
    color: #666;
    line-height: 27px;
    font-size: 15px;
  }

  /* Responsive */

  @media (max-width: 991px) {
    .about-content {
      padding: 30px 15px;
    }

    .icon {
      width: 60px;
      height: 60px;
      font-size: 26px;
    }

    .content h4 {
      font-size: 18px;
    }

    .section-title h2 {
      font-size: 28px;
    }
  }
`;

export default ChairmanMessage;
